<h1 mat-dialog-title>Confirm the action</h1>
<mat-dialog-content *ngIf="data && data.description">{{data.description}}</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close="" cdkFocusInitial>Cancel</button>
  <button mat-button (click)="confirm()" >Confirm</button>

</div>
